"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONTACT_TYPES = void 0;
exports.CONTACT_TYPES = Object.freeze({
    EMAIL: 'email',
    PHONE: 'phone'
});
